import React from "react";
import { Checkbox, Col, Divider, Row } from "antd";
import { FormItem, InputItem, InputNumberItem } from "../../../Components/Items";
import TextAreItem from "../../../Components/TextAreaItem";
import TimePickerItem from "../../../Components/TimePickerItem";
import SelectProyectosItem from "../../../Components/SelectProyectosItem";
import MapaPerimetroEditor from "../../../Components/MapaPerimetro/MapaPerimetroEditor";
import { secondsToHms, timeToSeconds } from "../../../Components/TimeConvertions";

// 0 = domingo ... 6 = sábado (igual que moment.day() en el backend)
const OPCIONES_DIAS = [
    { label: "Dom", value: 0 },
    { label: "Lun", value: 1 },
    { label: "Mar", value: 2 },
    { label: "Mié", value: 3 },
    { label: "Jue", value: 4 },
    { label: "Vie", value: 5 },
    { label: "Sáb", value: 6 },
];

const DIAS_DEFAULT = [1, 2, 3, 4, 5, 6];
const INICIO_DEFAULT_SEG = 6 * 3600;
const FIN_DEFAULT_SEG = 22 * 3600;

const LAYOUT_COMPLETO = { labelCol: { span: 24 }, wrapperCol: { span: 24 } };

// El anillo cerrado de un triángulo ya trae 4 puntos (el último repite al primero)
const validarArea = (_, value) =>
    value?.coordinates?.[0]?.length >= 4
        ? Promise.resolve()
        : Promise.reject(new Error("Dibuja el perímetro en el mapa"));

const valoresAPayload = (values) => ({
    nombre: values.nombre,
    descripcion: values.descripcion,
    proyectoId: values.proyectoId || null,
    precisionMaxMetros: values.precisionMaxMetros,
    ventanaDefault: {
        dias: values.dias || [],
        inicioSeg: timeToSeconds(values.horaInicio),
        finSeg: timeToSeconds(values.horaFin),
    },
    area: values.area,
});

const datosAValores = (data) => ({
    nombre: data.nombre,
    descripcion: data.descripcion,
    proyectoId: data.proyectoId,
    precisionMaxMetros: data.precisionMaxMetros,
    dias: data.ventanaDefault?.dias || [],
    horaInicio: secondsToHms(data.ventanaDefault?.inicioSeg ?? INICIO_DEFAULT_SEG),
    horaFin: secondsToHms(data.ventanaDefault?.finSeg ?? FIN_DEFAULT_SEG),
    area: data.area,
});

const CamposPerimetroChecada = ({ empresaId, headersToken }) => (
    <>
        <Row gutter={16}>
            <Col span={12}>
                <FormItem name="nombre" label="Nombre" required max={100} margin pattern>
                    <InputItem placeholder="Nombre" />
                </FormItem>
                <FormItem name="descripcion" label="Descripción" margin pattern>
                    <TextAreItem placeholder="Descripción" />
                </FormItem>
            </Col>
            <Col span={12}>
                <FormItem
                    name="proyectoId"
                    label="Proyecto"
                    margin
                    tooltip="Opcional. Las asistencias checadas en este perímetro se registran con este proyecto."
                >
                    <SelectProyectosItem
                        empresaId={empresaId}
                        headersToken={headersToken}
                        sinBorde
                        allowClear
                        width="100%"
                        placeholder="Proyecto"
                    />
                </FormItem>
                <FormItem
                    name="precisionMaxMetros"
                    label="Precisión máx. (m)"
                    margin
                    required
                    type="number"
                    min={10}
                    max={500}
                    initialValue={50}
                    tooltip="Si el GPS del celular reporta una precisión peor que esta, no se deja checar."
                >
                    <InputNumberItem placeholder="Metros" min={10} max={500} />
                </FormItem>
            </Col>
        </Row>

        <Divider orientation="left" plain style={{ fontSize: 12, color: "#888", margin: "8px 0" }}>
            Horario por defecto
        </Divider>
        <div style={{ fontSize: 12, color: "#888", marginBottom: 8 }}>
            Solo aplica cuando el empleado no tiene un Horario asignado ese día; si lo tiene, mandan las
            ventanas de entrada y salida de su Horario. Si la hora de fin es menor que la de inicio, la
            ventana cruza la medianoche.
        </div>
        <FormItem
            name="dias"
            label="Días"
            margin
            initialValue={DIAS_DEFAULT}
            tooltip="Sin días marcados, en este perímetro solo se podrá checar con Horario asignado."
        >
            <Checkbox.Group options={OPCIONES_DIAS} />
        </FormItem>
        <Row gutter={16}>
            <Col span={12}>
                <FormItem
                    name="horaInicio"
                    label="Desde"
                    margin
                    required
                    initialValue={secondsToHms(INICIO_DEFAULT_SEG)}
                >
                    <TimePickerItem placeholder="Desde" />
                </FormItem>
            </Col>
            <Col span={12}>
                <FormItem
                    name="horaFin"
                    label="Hasta"
                    margin
                    required
                    initialValue={secondsToHms(FIN_DEFAULT_SEG)}
                >
                    <TimePickerItem placeholder="Hasta" />
                </FormItem>
            </Col>
        </Row>

        <Divider orientation="left" plain style={{ fontSize: 12, color: "#888", margin: "8px 0" }}>
            Perímetro
        </Divider>
        <FormItem name="area" margin rules={[{ validator: validarArea }]} {...LAYOUT_COMPLETO}>
            <MapaPerimetroEditor />
        </FormItem>
    </>
);

export { valoresAPayload, datosAValores };
export default CamposPerimetroChecada;
